<script setup>
//环境仪表板
import { onMounted, ref } from 'vue';
import myCardCom from '../components/common/myCard.vue';
import environmentTable from '../components/environment/indexTable.vue';
import myRankCard from '../components/common/myRankCard.vue';
import { gethscodeByTemplate } from "@/service/apiList/productLine"
import { showMessage } from "@/utils/hooks/message"
import { useRouter } from 'vue-router';
// import i18n from "@/i18n"
import headerCom from '../components/common/header.vue';
import { getLangValue } from "@/utils/common"; //获取后端语言
const hscodeList = ref([])
const databaseList = ref([])

const router = useRouter()
// 获取hscode列表
const getDatasBaseListList = async () => {
    const resp = await gethscodeByTemplate()
    if (resp.code == 0) {
        databaseList.value = resp.payload.filter(item => item.destination_market_list.length).map(item => {
            return {
                label: item.name,
                label_en: item.name_en,
                value: item.name,
                children: item.destination_market_list.map(item1 => {
                    return {
                        label: item1.title,
                        label_en: item1.title_en,
                        value: item1.id,
                        database_template_list: item1.database_template_list
                    }
                })
            }
        })
    }
}

// const getHscodeList = async () => {
//     // 获取hscode列表
//     const resp = await getHscode({})
//     if (resp.code == 0) {
//         hscodeList.value = resp.payload
//     }
// }
const search = (index, query) => {
    let url = ''
    switch (index) {
        case 0:
            // 跳转到hscode环境碳足迹报告
            // router.push({path: '/dashboard-environment-digital-passport'})
            if (!query.hscode || !query.product_template_name) {
                showMessage('danger', getLangValue('dashboard.fillDataMessage1'))
                return
            }
            url = router.resolve({ path: '/dashboard-environment-digital-passport', query: query }).href
            break;
        case 1:
            if (!query.hscode || !query.product_template_name) {
                showMessage('danger', getLangValue('dashboard.fillDataMessage1'))
                return
            }
            url = router.resolve({ path: '/dashboard-environment-index-list', query: query }).href
            // 跳转到清单列表
            break;
        case 2:
            // 跳转到按环境碳足迹搜索产品
            if (!query.hscode || !query.product_template_name) {
                showMessage('danger', getLangValue('dashboard.fillDataMessage1'))
                return
            }
            url = router.resolve({ path: '/dashboard-environment-search-product', query: query }).href
            break;
        case 3:
            // 跳转到按环境碳足迹搜索认证机构
            if (!query.hscode || !query.product_template_name) {
                showMessage('danger', getLangValue('dashboard.fillDataMessage1'))
                return
            }
            url = router.resolve({ path: '/dashboard-environment-search-institution', query: query }).href
            break;
        default:
            break;
    }
    window.open(url, '_blank')
}


onMounted(() => {
    getDatasBaseListList()
    // getHscodeList();
})
</script>
<template>
    <!-- 环境碳足迹dashboard -->
    <div class="environment-dashboard1 my-scroll-bar px-2">
        <!-- <div class="header d-flex justify-content-between p-3 align-items-center">
            <div class="title">{{ getLangValue('dashboard.environment.title') }}</div>
            <div class="home d-flex  align-items-center cursor-pointer" @click="fullScreen">
                <span>HOME</span>
                <i class="bx bx-fullscreen ms-3" v-if="!isFullScreen"></i>
                <i class="bx bx-exit-fullscreen ms-3" v-else></i>
            </div>
        </div> -->
        <headerCom :title="getLangValue('dashboard.environment.title')" />
        <div class="main d-flex">
            <div class="left-aside  my-scroll-bar h-100" style="margin-bottom: 1.5rem;">
                <myCardCom class="mb-0" @search="(query) => search(0, query)" :hscodeList="hscodeList" :databaseList="databaseList"
                    :title="getLangValue('dashboard.environment.titleText')" :placeholder="getLangValue('dashboard.input1')" />
                <myCardCom :showInput1="false" class="mb-0"  @search="(query) => search(1, query)" :hscodeList="hscodeList" :databaseList="databaseList"
                    :title="getLangValue('dashboard.environment.titleText1')" :placeholder="getLangValue('dashboard.input2')" />
                <myCardCom class="mb-0" @search="(query) => search(2, query)" :hscodeList="hscodeList" :databaseList="databaseList"
                    :title="getLangValue('dashboard.environment.titleText2')" :placeholder="getLangValue('dashboard.input3_1')" />
                <myCardCom style="margin-bottom: 1.3rem !important;" @search="(query) => search(3, query)" :hscodeList="hscodeList" :databaseList="databaseList"
                    :title="getLangValue('dashboard.environment.titleText3')" :placeholder="getLangValue('dashboard.input3_1')" />
            </div>
            <div class="center mx-2">
                <div class="card px-3 py-2" style="height: calc(100% - 1.3rem ) ; border-radius: 0.55rem;">
                    <div class="my-card-header">{{ getLangValue('dashboard.environment.mainTitle') }}</div>
                    <hr class="my-2" style="background-color:  #E9EBEC; opacity: 1;border: unset;" />
                    <div class="my-card-content">
                        <environmentTable :hscodeList="hscodeList" :databaseList="databaseList" />
                    </div>
                </div>
            </div>
            <div class="right-aside">
                <div class="card card1 px-3 py-2" style="height: calc(100% - 1.3rem ) ; border-radius: 0.55rem;">
                    <myRankCard :hscodeList="hscodeList" :databaseList="databaseList" :category_id="5"
                        :title="getLangValue('dashboard.environment.titleText4')" :placeholder="getLangValue('dashboard.input1')" />
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.environment-dashboard {
    background-color: #2E404C;
    height: 100vh; //way-1
    // height: 100%; //way-2
    // overflow-y: auto; //way-2



    .main {
        height: calc(100vh - 60px); //way-1

        // min-height: calc(100vh - 60px); //way-2
        // height: auto; //way-2
        .left-aside {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 404px;
            overflow-y: auto;
        }

        .center {
            flex: 1; //way-1
            height: 100%; //way-1
            margin-bottom: 1.3rem; //way-1

            // height: auto;  //way-2
            // margin-bottom: 1.5rem; //way-2
            .card {
                background-color: #495057;
                border: 1px solid #D9D9D980;

                .my-card-header {
                    color: white;
                    font-size: 16px;
                    font-weight: 700;
                }

                .my-card-content {
                    height: calc(100% - 26px - 1rem);

                    .hscode {
                        color: #9599AD;
                        word-break: break-all;

                        .active {
                            color: white !important;
                        }
                    }

                    .search {
                        height: 38px;

                        :deep(.el-input--suffix) {
                            width: 110px;
                            height: 100%;
                        }

                        :deep(.el-input__wrapper) {
                            background-color: #4a5056;
                        }

                        :deep(.el-input__inner) {
                            color: white;
                        }

                        .form-control {
                            background-color: #4a5056;
                            color: white;
                        }
                    }
                }
            }
        }

        .right-aside {
            width: 480px;

            .card {
                background-color: #495057;
                border: 1px solid #D9D9D980;

            }
        }
    }
}

.environment-dashboard1 {
    // background-color: #2E404C;
    height: 100vh; //way-1
    // height: 100%; //way-2
    // overflow-y: auto; //way-2



    .main {
        height: calc(100vh - 60px); //way-1

        // min-height: calc(100vh - 60px); //way-2
        // height: auto; //way-2
        .left-aside {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 404px;
            overflow-y: auto;
        }

        .center {
            flex: 1; //way-1
            height: 100%; //way-1
            margin-bottom: 1.3rem; //way-1

            // height: auto;  //way-2
            // margin-bottom: 1.5rem; //way-2
            .card {
                // background-color: #495057;
                border: 1px solid #D9D9D980;

                .my-card-header {
                    color: #212529;
                    font-size: 16px;
                    font-weight: 700;
                }

                .my-card-content {
                    height: calc(100% - 26px - 1rem);

                    .hscode {
                        color: #9599AD;
                        word-break: break-all;

                        .active {
                            color: white !important;
                        }
                    }

                    .search {
                        height: 38px;

                        :deep(.el-input--suffix) {
                            width: 110px;
                            height: 100%;
                        }

                        :deep(.el-input__wrapper) {
                            background-color: #4a5056;
                        }

                        :deep(.el-input__inner) {
                            color: white;
                        }

                        .form-control {
                            background-color: #4a5056;
                            color: white;
                        }
                    }
                }
            }
        }

        .right-aside {
            width: 480px;

            .card {
                // background-color: #495057;
                border: 1px solid #D9D9D980;

            }
        }
    }
}
</style>
